import { render, staticRenderFns } from "./PressRelease-2023-01-11.vue?vue&type=template&id=67ecb32d&scoped=true"
import script from "./PressRelease-2023-01-11.vue?vue&type=script&lang=js"
export * from "./PressRelease-2023-01-11.vue?vue&type=script&lang=js"
import style0 from "./PressRelease-2023-01-11.vue?vue&type=style&index=0&id=67ecb32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ecb32d",
  null
  
)

export default component.exports